document.addEventListener("DOMContentLoaded", function () {
	const menuItems = window.menuItems || [];
	if (menuItems.length === 0) return

	function createMenu(items, isSubmenu = false) {
		if (!items.length) {
			return document.createElement("ul");
		}

		const ul = document.createElement("ul");
		ul.className = isSubmenu ? "children" : "filter-tree";

		items.forEach(item => {
			if (!item.links) {
				item.links = [];
			}

			const isActive = item.isActive;
			const hasActiveChildItem = item.hasActiveChild;

			if (isActive || hasActiveChildItem || isSubmenu) {
				const li = document.createElement("li");
				li.classList.add('filter-tree__item');
				if (isActive || hasActiveChildItem) {
					li.classList.add('filter-tree__item--active');
				}
				li.innerHTML = isActive
				? `<a href="${item.url}">${item.title}</a>`
				: `<a href="${item.url}">${item.title}</a>`;

				if (item.links.length > 0) {
					const childUl = createMenu(item.links, true);
					if (childUl.children.length > 0) {
						li.appendChild(childUl);
					}
				}

				ul.appendChild(li);
			}
		});
		return ul;
	}

	function wrapInFilterOptionList(menu) {
	const wrapper = document.createElement("div");
	wrapper.className = "boost-sd__filter-option boost-sd__filter-option-list";
	wrapper.dataset.filteroptionid = "pf_m_::related";

	wrapper.innerHTML = `
		<!-- TEMPLATE FILTER OPTION LIST -->
		<!-- TEMPLATE FILTER OPTION LABEL -->
		<div id="pf_m___related-toggle-target-label" class="boost-sd__filter-option-label">
			<button id="pf_m___related-toggle" aria-expanded="true" aria-label="Filter by: Gerelateerde categorieën" class="boost-sd__filter-option-title" data-metadata='{"action":{"filterOptionCollapse":{"actionId":"pf_m___related-toggle"}}}'>
				Gerelateerde Categorieën
				<svg class="boost-sd__filter-option-icon" xmlns="http://www.w3.org/2000/svg" width="7" height="12" role="img" aria-label="Filter by: Gerelateerde categorieën" viewBox="0 0 7 12" fill="#222">
					<path class="boost-sd__filter-option-path" d="M6.58942 0.610713C6.26398 0.285274 5.73635 0.285274 5.41091 0.610713L0.611415 5.41021C0.455135 5.56649 0.366829 5.77895 0.366829 5.99996C0.366829 6.22098 0.454629 6.43294 0.610909 6.58922L5.41091 11.3892C5.73635 11.7147 6.26398 11.7147 6.58942 11.3892C6.91486 11.0638 6.91486 10.5362 6.58942 10.2107L2.37867 5.99996L6.58942 1.78922C6.91486 1.46379 6.91486 0.936153 6.58942 0.610713Z"></path>
				</svg>
			</button>
		</div>
		<div id="pf_m___related-toggle-target" class="boost-sd__filter-option-itemwrapper">
			<div class="boost-sd__filter-option-content-inner boost-sd__filter-option-content-inner--scrollbar"></div>
		</div>
	`;

	// Plaats de UL in de content-inner div
	const innerContainer = wrapper.querySelector('.boost-sd__filter-option-content-inner');
	innerContainer.appendChild(menu);

	return wrapper;
}

const generatedMenu1 = wrapInFilterOptionList(createMenu(menuItems));
const generatedMenu2 = wrapInFilterOptionList(createMenu(menuItems));

	if (generatedMenu1.children.length > 0) {
		// clone the menu so it can be injected twice
		const generatedMenu2 = createMenu(menuItems);
		const boostFilterTreeEl = document.querySelectorAll(".boost-sd__filter-tree-vertical-option-list");

		if (boostFilterTreeEl.length > 0) {
			boostFilterTreeEl[0].insertAdjacentElement('afterbegin', generatedMenu1);
			boostFilterTreeEl[1].insertAdjacentElement('afterbegin', generatedMenu2);
		}
		else {
			let hasEl = false
			let interval = setInterval(() => {
				const boostFilterTreeEl = document.querySelectorAll(".boost-sd__filter-tree-vertical-option-list");

				if (boostFilterTreeEl.length > 0) {
					boostFilterTreeEl[0].insertAdjacentElement('afterbegin', generatedMenu1);
					boostFilterTreeEl[1].insertAdjacentElement('afterbegin', generatedMenu2);
					hasEl = true;
				}

				if (hasEl) {
					clearInterval(interval);
				}
			}, 250);
		}
	}
});
//# sourceMappingURL=custom-menu.js.map
document.addEventListener("click", function (e) {
	const toggleBtn = e.target.closest("#pf_m___related-toggle");
	if (!toggleBtn) return;

	const target = document.getElementById("pf_m___related-toggle-target");
	const labelContainer = document.getElementById("pf_m___related-toggle-target-label");
	if (!target || !labelContainer) return;

	const expanded = toggleBtn.getAttribute("aria-expanded") === "true";

	// Toggle aria-expanded
	toggleBtn.setAttribute("aria-expanded", !expanded);

	// Toggle target display
	target.style.display = expanded ? "none" : "block";

	// Toggle collapsed class on label
	if (expanded) {
		labelContainer.classList.add("boost-sd__filter-option-label--collapsed");
	} else {
		labelContainer.classList.remove("boost-sd__filter-option-label--collapsed");
	}
});
